<template>
  <div>
    <links-wrapper
      :active="openFooterLinksWrapper"
      :links="findLinks"
      title="Encontre seu curso"
      @display="title => display(title)"
    />
    <links-wrapper
      :active="openFooterLinksWrapper"
      :links="helpLinks"
      title="Central de Ajuda"
      @display="title => display(title)"
    />
    <links-wrapper
      :active="openFooterLinksWrapper"
      :links="revistaLinks"
      title="Revista Quero"
      @display="title => display(title)"
    />
    <links-wrapper
      :active="openFooterLinksWrapper"
      :links="institutionalLinks"
      title="Institucional"
      @display="title => display(title)"
    />
    <links-wrapper
      :active="openFooterLinksWrapper"
      :links="tipsLinks"
      title="Dicas Quero Bolsa"
      @display="title => display(title)"
    />
  </div>
</template>

<script>
  import LinksWrapper from '~/components/footer/links-wrapper';

  export default {
    data() {
      return {
        openFooterLinksWrapper: '',
      }
    },
    components: {
      LinksWrapper,
    },
    computed: {
      findLinks() {
        return [
          { name: 'Cursos de Idiomas', path: '/idiomas?utm_source=querobolsa&utm_medium=referral&utm_campaign=link-footer', targetBlank: true, rel: true },
          { name: 'Cursos Livres', path: '/cursos-livres' },
          { name: 'Cursos EaD', path: '/ead-a-distancia' },
          { name: 'Cursos Tecnólogos', path: '/cursos-tecnologos' },
          { name: 'Cursos Pós-Graduação', path: '/pos-graduacao' },
        ];
      },
      helpLinks() {
        return [
          { name: 'Passo a Passo', path: '/como-funciona' },
          { name: 'Termos e Condições', path: '/termos_e_condicoes' },
          { name: 'Política de Privacidade', path: '/politica_de_privacidade' },
          { name: 'Vs Educa Mais Brasil', path: '/educamaisbrasil' },
          { name: 'Vs Mais Estudo/Neora', path: '/maisestudo' },
        ];
      },
      revistaLinks() {
        return [
          { name: 'Vestibular e Enem', path: '/revista/assunto/vestibular-e-enem', targetBlank: true, rel: true },
          { name: 'Dicas e Curiosidades', path: '/revista/assunto/dicas-e-curiosidades', targetBlank: true, rel: true },
          { name: 'Especiais', path: '/revista/assunto/especiais', targetBlank: true, rel: true },
          { name: 'Profissões', path: '/revista/assunto/profissoes', targetBlank: true, rel: true },
          { name: 'Pós-Graduação', path: '/revista/assunto/pos-graduação', targetBlank: true, rel: true },
          { name: 'Idiomas', path: '/revista/assunto/idiomas', targetBlank: true, rel: true },
          { name: 'Manual do Enem', path: '/enem/manual-do-enem', targetBlank: true, rel: true },
          { name: 'Gabarito do Enem', path: '/enem/gabarito', targetBlank: true, rel: true },
        ];
      },
      institutionalLinks() {
        return [
          { name: 'Trabalhe conosco', path: 'https://jobs.lever.co/quero.education', targetBlank: true },
          { name: 'Portal do Parceiro', path: 'https://queroalunos.com', targetBlank: true, rel: true },
          { name: 'Quero ser Parceiro', path: 'https://gestores.queroeducacao.com.br', targetBlank: true, rel: true },
          { name: 'Imprensa', path: 'mailto:imprensa@querobolsa.com.br' },
          { name: 'Captação de Alunos', path: 'https://gestores.queroeducacao.com.br', targetBlank: true, rel: true },
          { name: 'App', path: 'https://play.google.com/store/apps/details?id=com.redealumni.appquerobolsa&hl=pt_BR', targetBlank: true, rel: true },
        ];
      },
      tipsLinks() {
        return [
          { name: 'Intercâmbio', path: '/intercambio?utm_source=querobolsa&utm_medium=referral&utm_campaign=link-footer', targetBlank: true, rel: true},
          { name: 'Vagas em escolas', path: '/escolas', targetBlank: true, rel: true },
          { name: 'Serviços Parceiros', path: '/servicos-recomendados', targetBlank: true, rel: true },
          { name: 'Quero Pontos', path: '/indicacoes/registrar-se', targetBlank: true, rel: true },
          { name: 'Cursos Gratuitos', path: '/carreiras/cursos-gratuitos', targetBlank: true, rel: true },
          { name: 'Cursos Online', path: 'https://pt-br.classpert.com', targetBlank: true, rel: true },
          { name: 'Portal do Aluno', path: '/portal-do-aluno', targetBlank: true, rel: true },
          { name: 'quero.com', path: 'https://quero.com', targetBlank: true, rel: true},
        ];
      },
    },
    methods: {
      display(title) {
        this.openFooterLinksWrapper = title;
      }
    }
  }
</script>
